import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Meta from "./../../pages/Meta";

const intentData = {
    crm: {
        name: "CRM",
        description: "A top CRM software for automation.",
        sectionTwo: { needBullets: ["Bullet 1", "Bullet 2", "Bullet 3"] },
        sectionThree: ["Point 1", "Point 2"],
    },
    sales: {
        name: "Sales",
        description: "A powerful sales tracking tool.",
        sectionTwo: { needBullets: ["Bullet A", "Bullet B", "Bullet C"] },
        sectionThree: ["Point A", "Point B"],
    }
};

const totalNames = Object.keys(intentData);


const updateSEO = (title, description, keywords, ogImage) => {
    console.log("SEO Updated:", { title, description, keywords, ogImage });
};

const SeoPage = () => {

    const { slug } = useParams();
    const navigate = useNavigate();
    const [dataObject, setDataObject] = useState(null);
    const [printNeedBullets, setPrintNeedBullets] = useState([]);
    const [rightCrmPoints, setRightCrmPoints] = useState([]);
    const year = new Date().getFullYear();

    const shuffle = (array) => array.sort(() => Math.random() - 0.5);

    useEffect(() => {
        if (!totalNames.includes(slug)) {
            navigate("/404");
            return;
        }

        const data = intentData[slug];
        setDataObject(data);
        setPrintNeedBullets(shuffle(data?.sectionTwo?.needBullets || []));
        setRightCrmPoints(data?.sectionThree || []);

        // Update SEO
        updateSEO(
            `India's Top Automated CRM Software for ${data?.name} in ${year}`,
            `${data?.description}`,
            `Best CRM Software for ${data?.name}`,
            "https://www.salezshark.com/assets/images/crm/crm-index.png"
        );
    }, [slug, navigate]);

    if (!dataObject) return <p>Loading...</p>;

    return (
        <>
         <Meta title={`India's Top Automated CRM Software for ${dataObject.name} in ${year}`} description={dataObject.description} />
     

            <h1>{dataObject.name} CRM</h1>
            <p>{dataObject.description}</p>

            <h2>Key Benefits</h2>
            <ul>
                {printNeedBullets.map((bullet, index) => (
                    <li key={index}>{bullet}</li>
                ))}
            </ul>

            <h2>CRM Features</h2>
            <ul>
                {rightCrmPoints.map((point, index) => (
                    <li key={index}>{point}</li>
                ))}
            </ul>
        </>
    );

}

export default SeoPage;
